<template>
  <div class="accordion" :class="{ 'is-collapsed': isCollapsed }">
    <h3 class="accordion__headline">
      <button class="accordion__btn-trigger" @click="toggle" :title="$t('toggle')">
        <i class="material-icons m-r-small" v-if="isCollapsed">keyboard_arrow_down</i>
        <i class="material-icons m-r-small" v-else>keyboard_arrow_right</i>
        <slot name="headline">headline</slot>
      </button>
    </h3>
    <div class="accordion__content">
      <slot name="content">inhalt</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',

  props: {
    open: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      isCollapsed: false
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.isCollapsed = this.open;
    },

    toggle() {
      this.isCollapsed = !this.isCollapsed;
    }
  },

  watch: {
    open() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion {
  overflow: hidden;

  &--stacked {
    border-bottom: 1px solid $c-light-gray;
  }

  &.is-collapsed {
    .accordion__content {
      max-height: 99rem;
    }
  }

  &__headline {
    font-size: 1.2rem;
  }

  &__content {
    transition: all 0.3s ease-in-out;
    max-height: 0;
    overflow: hidden;
  }

  &__btn-trigger {
    font-size: inherit;
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    outline: none;
    padding: 0 1rem;
    transition: color 0.3s ease-in-out;
    width: 100%;

    &:hover {
      color: $c-brand;
    }
  }
}
</style>
